import { useState } from "react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toDate = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };

export const DatePickerBR = ({ value, min, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const day = value ? toDate(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="flex h-10 min-w-0 flex-1 items-center gap-2 rounded-md border border-zap-line bg-white px-3 text-left text-sm transition-colors hover:bg-zap-mist">
          <CalendarDays className="h-4 w-4 shrink-0 text-zap-deep" />
          <span className="truncate capitalize">{day ? format(day, "EEE, dd/MM/yyyy", { locale: ptBR }) : "Escolher o dia"}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={ptBR} selected={day} defaultMonth={day}
          disabled={min ? { before: toDate(min) } : undefined}
          formatters={{ formatCaption: (m) => { const s = format(m, "LLLL yyyy", { locale: ptBR }); return s[0].toUpperCase() + s.slice(1); } }}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          data-testid={`${testId}-calendar`} />
      </PopoverContent>
    </Popover>
  );
};
